export default __webpack_public_path__ + "static/media/Group 8243.76681bfb.png";